import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Grid} from "@mui/material";
import Badge from "../../../Badge";
import CustomButton from "../../../CustomButton";
import SelectTitle from "../../../radioGroup/SelectTitle";
import RadioGroup from "../../../radioGroup/RadioGroup";
import {FormattedMessage} from "react-intl";
import FormControlLabel from "../../../radioGroup/FormControlLabel";

ChoiceList.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    choice: PropTypes.object.isRequired,
    setChoice: PropTypes.func.isRequired,
    choiceList: PropTypes.array.isRequired,
    isSelect: PropTypes.bool
};

function ChoiceList({title, choice, setChoice, choiceList, isSelect = false}) {
    const [unselect, setUnselect] = useState(false)

    const handleChange = (event) => {
        let selectedChoice = choiceList.find(choice => choice.id === event.currentTarget.value)
        if (!unselect && selectedChoice) {
            setChoice(selectedChoice)
        }
    }

    useEffect(() => {
        if (unselect) {
            setUnselect(false)
        }
    }, [choice]);

    return (
        <>
            {isSelect && (
                <Grid container direction={"column"}>
                    <span style={{
                        fontSize: "12px",
                        fontWeight: 600
                    }}>
                        {title}
                    </span>
                    <RadioGroup
                        alignListWithButton
                        selectedValueLabel={choice?.name}
                        value={choice?.id ?? null}
                        placeholder={<FormattedMessage id={"wms.associations.add.wmsPlaceChoicePlaceholder"}/>}
                        onChange={handleChange}
                    >
                        {choiceList && choiceList.map((choice, index) => (
                            <FormControlLabel
                                key={index}
                                disabled = {choice.disabled}
                                value={choice.id}
                                label={choice.name}
                                onClick={() => {
                                    if (choice.isSelectedSecond) {
                                        setChoice(choice)
                                        setUnselect(true)
                                    }
                                }}
                            />
                        ))}
                    </RadioGroup>
                </Grid>
            )}

            {!isSelect && (
                <Grid container direction={"column"} gap={"8px"}>
            <span style={{
                fontSize: "12px",
                fontWeight: 600
            }}>
                {title}
            </span>

                    <Grid container gap={"8px"}>
                        {choiceList && choiceList.map(choiceEntry => {
                            let isSelected = false
                            if (choice) {
                                isSelected = choice.id === choiceEntry.id
                            }
                            return (
                                <CustomButton
                                    disabled={choiceEntry.disabled}
                                    color={isSelected ? "default" : "idle"}
                                    onClick={() => setChoice(choiceEntry)}
                                    variant={isSelected ? "outlined" : ""}
                                    rounded
                                >
                                    {choiceEntry.name}
                                </CustomButton>
                            )
                        })}
                    </Grid>
                </Grid>
            )}
        </>
    );
}

export default ChoiceList;